/* eslint-env jquery */
(function ($) {
  if ($('.logo-carousel').length) {
    $(document).ready(setInterval(logoCarousel, 0));
  }

  function logoCarousel() {
    const logocarousel = $('.logos');
    const clients = logocarousel.children().length;
    const clientwidth = clients * 200; // 140px width for each client item
    logocarousel.css('width', clientwidth);
    const $first = $('.logos div:first');
    $first.animate({ 'margin-left': '-200px' }, 3000, 'linear', () => {
      $first.remove().css({ 'margin-left': '0px' });
      $('.logos div:last').after($first);
    });
  }
})(jQuery);
